import Head from 'next/head';
import { Text, AlertModal } from '@pairy/pds-react';
import { useMediaQuery } from 'react-responsive';

import { SetState } from '../../../types/helper';

import * as Styled from './index.styles';

interface Props {
  name: string;
  thumnail: string;
  alertModalOpen: boolean;
  setAlertModalOpen: SetState<boolean>;
  isKakaoInAppBrowser: boolean;
  translateKoToEn: (item: string) => string;
}

const Loading = ({
  name = 'loading',
  thumnail = 'https://assets.vercel.com/image/upload/front/nextjs/twitter-card.png',
  alertModalOpen,
  setAlertModalOpen,
  isKakaoInAppBrowser,
  translateKoToEn,
}: Props) => {
  const isMobile = useMediaQuery({ maxWidth: 375 });

  return (
    <>
      <Head>
        <title key="title">{name}</title>
        <meta key="metaTitle" name="title" content={name} />
        <meta key="ogTitle" property="og:title" content={name} />
        <meta key="ogImage" property="og:image" content={thumnail} />
        <meta key="description" name="description" lang="ko" content={name} />
        <meta key="ogDescription" property="og:description" content={name} />
      </Head>
      <Styled.FlexWrapper justifyContent="center" alignItems="center">
        <Text
          variant={isMobile ? 'lg-medium' : 'xl-medium'}
          color="skyblue_500"
        >
          {isKakaoInAppBrowser
            ? '외부 브라우저로 확인해주세요.'
            : translateKoToEn('loading')}
        </Text>
      </Styled.FlexWrapper>
      <AlertModal
        isOpen={alertModalOpen}
        setIsOpen={setAlertModalOpen}
        title={translateKoToEn('not-found-title')}
        closeButtonText={translateKoToEn('not-found-modal-close')}
        confirmButtonText={translateKoToEn('not-found-modal-button')}
        handleModalCloseAction={() => {
          window.location.href = 'https://app.salesclue.io/404';
        }}
      >
        <Text as="p" variant="md-medium" color="black">
          {translateKoToEn('not-found-content')}
        </Text>
      </AlertModal>
    </>
  );
};

export default Loading;
